import { render, staticRenderFns } from "./KeywordComponent.vue?vue&type=template&id=f8ec66da&scoped=true&"
import script from "./KeywordComponent.vue?vue&type=script&lang=js&"
export * from "./KeywordComponent.vue?vue&type=script&lang=js&"
import style0 from "./KeywordComponent.vue?vue&type=style&index=0&id=f8ec66da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ec66da",
  null
  
)

export default component.exports